import React, {useState} from 'react';
import {Col, Container, Table} from 'react-bootstrap';
import {httpClient} from "../../service";
import {ActionResult, HttpMethod} from "../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import {CouponJson} from "../../model/coupons/CouponJson";
import CouponVerifyListDetail from "./CouponVerifyListDetail";
import {Link} from 'react-router-dom';
import {getSessionCustNo, getSessionVerify} from './VerifyConfigModel';

const CouponVerifyList = () => { // 추가
    const url = 'test/verifications/coupon/list';
    const [submitting, setSubmitting] = useState(false);
    const options = {promiseFn: httpClient, method: HttpMethod.GET, url};
    const {data: act, error, isLoading, run: refresh} = useAsync<ActionResult>(options);
    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage action={act}/>;
    const data: CouponJson[] = act.data;
    const sessionModel=getSessionVerify();
    const initializeClick = async (e: any) => {
        e.preventDefault();
        console.log(`click button id=${e.target}`);
        setSubmitting(true);
        const url = 'test/verifications/coupon/initialize';
        const param=sessionModel;
        const options = {
            method: HttpMethod.DELETE,
            url,
            body:param
        }
        const act = await httpClient(options);
        setSubmitting(false);

        if (act.result) {
            alert("성공적으로 초기화 되었습니다.");
            refresh();
        } else {
            alert(act.errorMsg);
        }
    }
    return (
        <>
            <div className="bloc l-bloc">
                <Container className="bloc-sm">
                    <div className="row mb-1">
                        <Col className="text-left col-sm-6">
                            <Link to="/verifications" className="btn btn-sm btn-primary">Home</Link>
                        </Col>
                        <Col className="col-sm-6 text-right">
                            [<span className="text-primary">{sessionModel.custNo}</span>님]
                            <button className="btn-secondary" onClick={initializeClick} disabled={submitting}>발급내역
                                초기화</button>
                        </Col>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <Table striped bordered hover size="sm" variant="dark">
                                <colgroup>
                                    <col style={{width: '40px'}}/>
                                    <col style={{width: '70px'}}/>
                                    <col style={{width: '20%'}}/>
                                    <col style={{width: '10%'}}/>
                                    <col style={{width: '20%'}}/>
                                    <col style={{width: '90px'}}/>
                                    <col/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th className="align-center">#</th>
                                    <th className="align-center">id</th>
                                    <th>쿠폰혜택</th>
                                    <th className="align-center">유효기간</th>
                                    <th>쿠폰내용</th>
                                    <th className="align-center">검증</th>
                                    <th>발급내용</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data.map((item, i) => {
                                        return <CouponVerifyListDetail item={item} key={i} index={i}/>
                                    })
                                }
                                </tbody>
                            </Table>
                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
};

export default CouponVerifyList;
